<template>
  <div>
    <div id="dialogTarget" class="control-section; position:relative" style="height: 350px">
      <!-- Render Button to open the modal Dialog -->
      <!-- <ejs-button id="dlgbtn" ref="dlgbtn" v-on:click.native="dlgBtnClick"></ejs-button> -->
      <!-- Render modal Dialog -->
      <ejs-dialog
        ref="modalDialog"
        :isModal="isModal"
        :header="header"
        :target="target"
        :width="width"
        :closeOnEscape="closeOnEscape"
        :animationSettings="animationSettings"
        :close="modalDlgClose"
      >
        <div class="align-center-force-password">
          <!-- <div tabindex="0" class="e-card" style="width:550px;"> -->
          <!-- <div class="e-card-title"> Update Password </div> -->
          <div class="e-card-content margin-color-verify-section">
            <span style="color: red; display: block; margin-bottom: 2%">
              {{ notifyErrorMessage }}</span
            >
            <span style="color: green; display: block; margin-bottom: 2%">
              {{ notifySuccessMessage }}</span
            >
            <web-login-info
              ref="refwebLoginInfo"
              :userProfilesData="currentUser"
              :userProfileId="userId"
              :enableForcePasswordChange="false"
            />
            <security-questions
              v-if="enableSecurityQuestions"
              ref="refSecurityQuestions"
              :user-profile-id="userId"
              :user-profiles-data="currentUser"
            />
            <div class="align-center-bottom">
              <ejs-button
                type="button"
                v-on:click.native="dlgButtonClick"
                cssClass="e-info margin-button"
                >Submit</ejs-button
              >
            </div>
          </div>
          <!-- </div> -->
        </div>
      </ejs-dialog>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import WebLoginInfo from "../../user-accounts/components/web-login-info.vue";
import { SIGN_USER_OUT } from "../store";
import SecurityQuestions from "../../user-accounts/components/security-questions.vue";

Vue.use(DialogPlugin);
Vue.use(ButtonPlugin);

export default {
  name: "ForceChangePassword",
  components: {
    WebLoginInfo,
    SecurityQuestions,
  },
  data() {
    return {
      target: "#app",
      width: "750px",
      header: "Change Password",
      // buttons: [{ click: this.dlgButtonClick,
      // buttonModel: { content: 'save', isPrimary: true }, cssClass: 'e-info margin-button' }],
      isModal: true,
      animationSettings: { effect: "None" },
      closeOnEscape: false,
      notifyErrorMessage: "",
      notifySuccessMessage: "",
      enableSecurityQuestions: null,
    };
  },
  created() {
    this.enableSecurityQuestions = this.$route.query.enablesecurityQuestions
      ? this.$route.query.enablesecurityQuestions
      : false;
  },
  computed: {
    username() {
      return this.$store.getters.loggedUser
        ? this.$store.getters.loggedUser.email
        : this.fetchUserDetail();
    },
    currentUser() {
      return this.$store.getters.loggedUser
        ? this.$store.getters.loggedUser
        : this.fetchUserDetail();
    },
    userId() {
      return this.$store.getters.loggedUser
        ? this.$store.getters.loggedUser.id
        : this.fetchUserDetail();
    },
  },
  mounted() {
    // signout when user clicks on the back button in the browser
    window.onpopstate = (event) => {
      this.$store.dispatch(SIGN_USER_OUT);
    };
  },
  methods: {
    async fetchUserDetail() {
      /** This is commented out when the page level authorization is implemented. Todo: Refactor */
      // await this.$store.dispatch(FETCH_LOGGED_USER);
    },
    // dlgBtnClick() {
    //   this.$refs.modalDialog.show();
    // },
    modalDlgClose() {
      // document.getElementById("dlgbtn").style.display = "none";
    },
    dlgButtonClick() {
      // this.$parent.notificationToasts.length = 0;
      const loginInfo = this.$refs.refwebLoginInfo;
      const securityQuestion = this.$refs.refSecurityQuestions;
      let isFormValid = false;
      if (securityQuestion) {
        securityQuestion.validateSecurityQuestions();
      }

      if (
        loginInfo.isOldPasswordValid
        && loginInfo.isPasswordValid
        && loginInfo.isConfirmPassword
      ) {
        // this.$parent.notificationToasts.length = 0;

        if (this.enableSecurityQuestions) {
          const inValidFields = [];

          const { isSecurityAnswerOne } = securityQuestion;
          const { isSecurityAnswerTwo } = securityQuestion;
          const { isSecurityAnswerThree } = securityQuestion;
          const { isConfirmAnswerOne } = securityQuestion;
          const { isConfirmAnswerTwo } = securityQuestion;
          const { isConfirmAnswerThree } = securityQuestion;

          isFormValid = isSecurityAnswerOne
            && isSecurityAnswerTwo
            && isSecurityAnswerThree
            // && securityQuestion.ddlSecurityQuestionOne !== null
            && isConfirmAnswerOne
            && isConfirmAnswerTwo
            && isConfirmAnswerThree;
          // && securityQuestion.ddlSecurityQuestionTwo !== null
          // && securityQuestion.ddlSecurityQuestionThree !== null;

          if (!isSecurityAnswerOne || !isConfirmAnswerOne) {
            inValidFields.push("Answer 1");
          }
          if (!isSecurityAnswerTwo || !isConfirmAnswerTwo) {
            inValidFields.push("Answer 2");
          }
          if (!isSecurityAnswerThree || !isConfirmAnswerThree) {
            inValidFields.push("Answer 3");
          }

          if (isFormValid) {
            securityQuestion.securityQuestions();
            this.notifySuccessMessage = "Security questions updated successfully.";
          } else {
            securityQuestion.validateSecurityQuestions();
          }
        }

        if (!this.enableSecurityQuestions || (this.enableSecurityQuestions && isFormValid)) {
          loginInfo.changePassword().then(() => {
            this.$router.push("/email-sent");
          });
          this.notifyErrorMessage = "";
          if (this.notifySuccessMessage) {
            this.notifySuccessMessage = "<br>Your password has successfully changed.";
          } else {
            this.notifySuccessMessage = "Your password has successfully changed.";
          }
          this.$parent.notificationToasts.push({
            title: "Success!",
            content: this.notifySuccessMessage,
            cssClass: "e-toast-success",
            timeOut: 5000,
          });
          this.$refs.modalDialog.hide();
        }
      } else {
        loginInfo.validatePassword();
        this.notifySuccessMessage = "";
        this.notifyErrorMessage = "Please enter value in required fields.";
        this.$parent.notificationToasts.push({
          title: "Error!",
          content: this.notifyErrorMessage,
          cssClass: "e-toast-danger",
          timeOut: 5000,
        });
      }
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }
    },
  },
};
</script>
<style>
@import "../../../../node_modules/@syncfusion/ej2-vue-popups/styles/material.css";

.control-section {
  height: 100%;
  min-height: 200px;
}
.wrap {
  box-sizing: border-box;
  margin: 0 auto;
  width: 260px;
}
.e-dlg-container .e-float-input {
  margin: 17px 0;
}
.e-dlg-container .wrap .e-control .e-btn {
  margin: 3% 26%;
}

.text-center {
  text-align: center;
}

#content {
  margin-top: 12px;
}

.e-dlg-container .e-footer-content {
  padding: 20px 0 0;
  width: 100%;
}

.e-dlg-container .e-dialog .e-footer-content .e-btn {
  width: 100%;
  height: 36px;
  margin-left: 0px;
}

.e-dlg-container .e-dialog .e-footer-content {
  padding: 0 18px 18px;
}
.e-dlg-container .e-dialog .e-dlg-header-content .e-dlg-header {
  color: #fff;
  font-weight: 500;
  text-align: center;
  width: 100%;
  font-size: 20px;
}
.e-dlg-header-content {
  background-color: #0f4b90;
}
.align-center-bottom {
  display: block;
  text-align: center;
  margin-top: 5%;
}
.align-center-force-password {
  justify-content: center;
}
.e-btn.e-info,
.e-css.e-btn.e-info {
  /* height: 35px; */
  background-color: #dba832 !important;
  color: white !important;
}
.e-btn.e-info:hover,
.e-css.e-btn.e-info:hover {
  background-color: #dba832 !important;
  color: white !important;
}
.e-btn.e-info:active,
.e-btn.e-info.e-active,
.e-css.e-btn.e-info:active,
.e-css.e-btn.e-info.e-active {
  background-color: #dba832 !important;
  color: white i !important;
}
.e-popup.e-popup-open.e-dialog {
  width: 750px !important;
}
</style>
